interface Links {
  url: string;
  rel: string;
  attributes?: Record<string, string>;
  enabled?: boolean;
}

export const linkStore: Links[] = [
  {
    url: "https://fonts.googleapis.com",
    rel: "preconnect",
    enabled: true,
  },
  {
    url: "https://fonts.gstatic.com",
    rel: "preconnect",
    attributes: { crossorigin: "anonymous" },
    enabled: true,
  },
  {
    url: "https://img.sportradar.com/ls/crest/medium/",
    rel: "preconnect",
    enabled: false,
  },

  {
    url: "https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined|Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200",
    rel: "stylesheet",
    enabled: true,
  },
  {
    url: "assets/widget.css",
    rel: "stylesheet",
    attributes: { type: "text/css" },
    enabled: false,
  },
  {
    url: "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css",
    rel: "stylesheet",
    attributes: { type: "text/css" },
    enabled: true,
  },
];
